import { createTheme } from '@mui/material';

export const getCheckboxTheme = () => {
  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#D3D3D3',
              borderRadius: 30,
              '& fieldset': {
                borderRadius: 30,
                border: '1px solid #122B87',
              },
              '&:hover fieldset': {
                border: '2px solid #122B87',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#122B87',
              },
              '& .MuiChip-label': {
                fontSize: '1rem',
                lineHeight: '1.5rem',
              },
            },
          },
        },
      },
    },
  });

  return theme;
};
